import Vue from "vue";
import VueRouter from 'vue-router'
import PaymentsDue from "../components/payments/payments-due";
import Welcome from "../pages/welcome";
import Dashboard from "../pages/dashboard";
import Reports from "../components/reports";
import Search from "../pages/Search/search";
import Spam from "../pages/Spam/spam";
import GenerateInvoicePage from "../pages/GenerateInvoice/generate-invoice-page";


import cookieModel from "../models/cookie";
import login from "../models/login";

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: "/",
            name: "Welcome",
            component: Welcome,
            props: true
        },
        {
            path: "/login",
            name: "Login",
            component: Welcome,
            props: true
        },
        {
            path: "/dashboard",
            name: "Dashboard",
            component: Dashboard,
            props: true
        },
        {
            path: "/search",
            name: "Search",
            component: Search,
            props: true
        },
        {
            path: "/payments/due",
            name: "PaymentsDue",
            component: PaymentsDue,
            props: true
        },
        {
            path: "/payments/due/:id",
            name: "PaymentsDueId",
            component: PaymentsDue,
            props: true
        },
      {
            path: "/payments/past/:id",
            name: "PaymentsPastId",
            component: PaymentsDue,
            props: true
        },
        {
            path: "/reports",
            name: "Reports",
            component: Reports,
            props: true
        },
        {
            path: "/spam",
            name: "Spam",
            component: Spam,
            props: true
        },
        {
            path: "/invoices/generate",
            name: "GenerateInvoice",
            component: GenerateInvoicePage,
            props: true
        }
    ]
});

// check if user is logged in
router.beforeEach((to, from, next) => {
  const isAuthenticated = login.isLoggedIn();
  if (to.name !== 'Login' && !isAuthenticated) {
    next({name: 'Login'});
  } else {
    next();
  }
});

export default router;
